import Image from "next/image";
import ProgressBar from "components/ui/ProgressBar/ProgressBar";
import styles from "./Pagination.module.scss";

export default function Pagination({
  currentPage,
  pageCount,
  handlePageChange,
  nextPageDisabled = false,
}) {
  return (
    <div className={`${styles.pagination}`}>
      <div className={`${styles.progress}`}>
        <ProgressBar progress={(currentPage / pageCount) * 100} />
      </div>
      <div className={`${styles.actions}`}>
        {currentPage > 1 && (
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            className={`${styles.paginationButton} ${styles.previous}`}
          >
            <span className={`${styles.arrow}`}>
              <Image
                src="/assets/img/icon/awrro-black.svg"
                alt="Arrow black icon"
                width="30"
                height="14"
              />
            </span>
            <span>Previous</span>
          </button>
        )}
        {currentPage === 1 && (
          <div
            className={`${styles.paginationButton} ${styles.previous} ${styles.placeholder}`}
          ></div>
        )}
        <span className={`${styles.pageNumber}`}>
          {currentPage} of {pageCount}
        </span>
        {currentPage < pageCount && (
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            className={`${styles.paginationButton} ${styles.next}`}
            disabled={nextPageDisabled}
          >
            <span>Next</span>
            <span className={`${styles.arrow}`}>
              <Image
                src="/assets/img/icon/awrro-black.svg"
                alt="Arrow black icon"
                width="30"
                height="14"
              />
            </span>
          </button>
        )}
        {currentPage === pageCount && (
          <div
            className={`${styles.paginationButton} ${styles.previous} ${styles.placeholder}`}
          ></div>
        )}
      </div>
    </div>
  );
}
